import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AchievementDefinitionDto, CreateAchievementDefinitionDto } from "../../../models/achievement/dto/achievement.dto";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_ACHIEVEMENTS_QUERY_KEY } from "./useListAchievements";

export const useCreateAchievement = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (input: CreateAchievementDefinitionDto) => {
            if (!selectedOrganization?.id) throw new Error('No organization selected');
            return client.fetchApi<AchievementDefinitionDto, CreateAchievementDefinitionDto>({
                endpoint: `achievements/admin/${selectedOrganization.id}`,
                method: 'POST',
                body: input,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_ACHIEVEMENTS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
